import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import SearchActions from 'app/actions/SearchActions';
import SearchScopeField from './SearchScopeField';

const mapStateToProps = state => ({
  scopes: selectCurrentSiteScopes(state),
  currentSearchScope: state.getIn(['search', 'catalogSearch', 'scope']),
  scopeFacetEnabled: selectCurrentLibrary(state).get('scopeFacetEnabled')
});

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch)
});

const SearchScopeFieldContainer = ({ scopes, currentSearchScope, scopeFacetEnabled }) => {
  if (!scopeFacetEnabled || typeof scopes === 'undefined' || scopes.size <= 1) {
    return null;
  }
  return <SearchScopeField scopes={scopes} currentSearchScope={currentSearchScope} />;
};

SearchScopeFieldContainer.propTypes = {
  scopes: ImmutablePropTypes.listOf(
    ImmutablePropTypes.contains({
      scopeName: PropTypes.string.isRequired,
      scopeId: PropTypes.string.isRequired,
      parentScopeId: PropTypes.string
    })
  ),
  scopeFacetEnabled: PropTypes.bool.isRequired,
  currentSearchScope: PropTypes.string
};

SearchScopeFieldContainer.displayName = 'SearchScopeFieldContainer';
export default connect(mapStateToProps, mapDispatchToProps)(SearchScopeFieldContainer);
